var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("admin.task_scheduler_description")))]),
          _c("br"),
          _c("h4", [_vm._v("Components")]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "repository_metadata_fetch",
              label: _vm.$t("admin.task_scheduler_repository_metadata_fetch"),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.repositoryMetadataFetch.description,
            },
            model: {
              value: _vm.repositoryMetadataFetch.value,
              callback: function ($$v) {
                _vm.$set(_vm.repositoryMetadataFetch, "value", $$v)
              },
              expression: "repositoryMetadataFetch.value",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "internal_component_identification",
              label: _vm.$t(
                "admin.task_scheduler_internal_component_identification"
              ),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.internalComponentIdentification.description,
            },
            model: {
              value: _vm.internalComponentIdentification.value,
              callback: function ($$v) {
                _vm.$set(_vm.internalComponentIdentification, "value", $$v)
              },
              expression: "internalComponentIdentification.value",
            },
          }),
          _c("br"),
          _c("h4", [_vm._v("Vulnerability databases synchronization")]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "ghsa_mirror",
              label: _vm.$t("admin.github_advisories"),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.ghsaMirror.description,
            },
            model: {
              value: _vm.ghsaMirror.value,
              callback: function ($$v) {
                _vm.$set(_vm.ghsaMirror, "value", $$v)
              },
              expression: "ghsaMirror.value",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "nist_mirror",
              label: _vm.$t("admin.nvd"),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.nistMirror.description,
            },
            model: {
              value: _vm.nistMirror.value,
              callback: function ($$v) {
                _vm.$set(_vm.nistMirror, "value", $$v)
              },
              expression: "nistMirror.value",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "vulndb_mirror",
              label: _vm.$t("admin.vulndb"),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.vulndbMirror.description,
            },
            model: {
              value: _vm.vulndbMirror.value,
              callback: function ($$v) {
                _vm.$set(_vm.vulndbMirror, "value", $$v)
              },
              expression: "vulndbMirror.value",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "osv_mirror",
              label: _vm.$t("admin.osv_advisories"),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.osvMirror.description,
            },
            model: {
              value: _vm.osvMirror.value,
              callback: function ($$v) {
                _vm.$set(_vm.osvMirror, "value", $$v)
              },
              expression: "osvMirror.value",
            },
          }),
          _c("br"),
          _c("h4", [_vm._v("Analysis")]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "portfolio_vulnerability_analysis",
              label: _vm.$t(
                "admin.task_scheduler_portfolio_vulnerability_analysis"
              ),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.portfolioVulnerabilityAnalysis.description,
            },
            model: {
              value: _vm.portfolioVulnerabilityAnalysis.value,
              callback: function ($$v) {
                _vm.$set(_vm.portfolioVulnerabilityAnalysis, "value", $$v)
              },
              expression: "portfolioVulnerabilityAnalysis.value",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "component_analysis_cache_clear",
              label: _vm.$t(
                "admin.task_scheduler_component_analysis_cache_clear"
              ),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.analysisCacheClear.description,
            },
            model: {
              value: _vm.analysisCacheClear.value,
              callback: function ($$v) {
                _vm.$set(_vm.analysisCacheClear, "value", $$v)
              },
              expression: "analysisCacheClear.value",
            },
          }),
          _c("br"),
          _c("h4", [_vm._v("Metrics update")]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "portfolio_metrics_update",
              label: _vm.$t("admin.task_scheduler_portfolio_metrics_update"),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.portfolioMetricsUpdate.description,
            },
            model: {
              value: _vm.portfolioMetricsUpdate.value,
              callback: function ($$v) {
                _vm.$set(_vm.portfolioMetricsUpdate, "value", $$v)
              },
              expression: "portfolioMetricsUpdate.value",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "vulnerability_metrics_update",
              label: _vm.$t(
                "admin.task_scheduler_vulnerability_metrics_update"
              ),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.vulnerabilityMetricsUpdate.description,
            },
            model: {
              value: _vm.vulnerabilityMetricsUpdate.value,
              callback: function ($$v) {
                _vm.$set(_vm.vulnerabilityMetricsUpdate, "value", $$v)
              },
              expression: "vulnerabilityMetricsUpdate.value",
            },
          }),
          _c("br"),
          _c("h4", [_vm._v("Authentication")]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "ldap_sync",
              label: _vm.$t("admin.task_scheduler_ldap_sync"),
              "input-group-size": "mb-3",
              rules: "required|min_value:1",
              type: "number",
              tooltip: _vm.ldapSync.description,
            },
            model: {
              value: _vm.ldapSync.value,
              callback: function ($$v) {
                _vm.$set(_vm.ldapSync, "value", $$v)
              },
              expression: "ldapSync.value",
            },
          }),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }